import { IconButton, darken, styled } from '@mui/material';
import { PauseCircle as PauseIcon } from '@mui/icons-material';
import PlayIcon from '@mui/icons-material/PlayArrowRounded';

export const StyledPlayIcon = styled(PlayIcon)(({ theme }) => ({
  height: theme.spacing(3),
  width: theme.spacing(3),
}));

export const StyledPauseIcon = styled(PauseIcon)(({ theme }) => ({
  height: theme.spacing(5.5),
  width: theme.spacing(5.5),
  color: theme.palette.primary.main,
  '&:hover': {
    color: darken(theme.palette.primary.main, 0.1),
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  aspectRatio: '1 / 1',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    backgroundColor: theme.palette.grey[700],
  },
}));

export const StyledPauseButton = styled(StyledIconButton)(() => ({
  padding: 0,
  '&:hover': {
    backgroundColor: 'initial',
  },
}));
